export const LOGOUT = 'logout';
export const LOGIN = 'login';
export const USER_DETAILS='user-details'
export const LOCATION_UPDATE = 'update-location';
export const PERMISSIONS = "permissions"
export const REGENERATE_TOKEN = "regenrate-token"
